import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CustomTabs, CustomTypography } from "sipli-fleet-core/components";
import TachographSettingsTab from "./TachographSettingsTab";
import LimitsTab from "./LimitsTab";

type CustomerSettingsInnerTab = "limits" | "modules" | "tachograph";

interface CustomerSettingsTabProps {
  clientId?: string;
  defaultActiveKey?: CustomerSettingsInnerTab;
}

const EmptySettingsPane = () => (
  <section className="customer-limits-panel customer-settings-empty-panel" />
);

const CustomerSettingsTab = ({
  clientId,
  defaultActiveKey = "limits",
}: CustomerSettingsTabProps) => {
  const { t } = useTranslation();
  const [activeKey, setActiveKey] = useState<CustomerSettingsInnerTab>(defaultActiveKey);

  useEffect(() => {
    setActiveKey(defaultActiveKey);
  }, [defaultActiveKey]);

  const tabItems = [
    {
      key: "limits",
      label: t("limits"),
      children: <LimitsTab clientId={clientId} />,
    },
    {
      key: "modules",
      label: t("modules", { defaultValue: "Modules" }),
      children: <EmptySettingsPane />,
      disabled: true,
    },
    {
      key: "tachograph",
      label: t("tachograph"),
      children: <TachographSettingsTab clientId={clientId} />,
    },
  ];

  return (
    <div className="customer-settings-card rounded-[16px] px-5 py-6 bg-auto !shadow-none">
      <CustomTypography.CustomText className="!block !text-[19.93px] !leading-[28px] !font-bold !text-black">
        {t("client_settings")}
      </CustomTypography.CustomText>

      <CustomTabs
        tabPosition="left"
        className="custom-tabs-customers customer-settings-tabs !mt-7"
        items={tabItems}
        activeKey={activeKey}
        onChange={(key) => setActiveKey(key as CustomerSettingsInnerTab)}
        destroyOnHidden={false}
      />
    </div>
  );
};

export default CustomerSettingsTab;
